// import { useKeycloak } from "@react-keycloak/web";
// import { keycloak } from "../keycloak";

export const getAuthHeader = () => {
    // if (process.env.REACT_APP_Keycloak === "true") {
    //     const kcToken = keycloak?.token ?? "";
    //     return {
    //         Authorization: kcToken ? `Bearer ${kcToken}` : "",
    //     };
    // }
    return { Authorization: "" };
};

export const useAuthHeader = () => {
    // const { keycloak, initialized } = useKeycloak();

    // if (process.env.REACT_APP_KC_ENABLED === "true") {
    //     const kcToken = keycloak?.token ?? "";
    //     return {
    //         Authorization: initialized && kcToken ? `Bearer ${kcToken}` : "",
    //     };
    // }
    return { Authorization: "" };
};
